import { AxiosInstance } from 'axios'

import {
  CreateEmployeesContractsRequest,
  UploadEmployeeAdmissionExamFileRequest,
} from '@modules/employees/types/EmployeesContracts/requests'
import { EmployeePerson } from '@modules/employees/types/EmployeesPersons/employeesPersons'

export class EmployeesContractsService {
  private instance: AxiosInstance

  constructor(instance: AxiosInstance) {
    this.instance = instance
  }

  async create(data: CreateEmployeesContractsRequest): Promise<EmployeePerson> {
    const { employeeId, ...body } = data

    const response = await this.instance.post(`/companies/employees/${employeeId}/contracts`, body)

    return response.data
  }

  async uploadAdmissionExam({ employeeId, file }: UploadEmployeeAdmissionExamFileRequest): Promise<EmployeePerson> {
    const formData = new FormData()
    formData.append('file', file)

    const response = await this.instance.post(`/companies/employees/${employeeId}/contracts/admission-exam`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })

    return response.data
  }
}

export const employeesContractsService = (instance: AxiosInstance) => new EmployeesContractsService(instance)
